// eslint-disable-next-line import/prefer-default-export
export const COLLABORATOR_ROLES = [
  'Director',
  'Assistant Director',
  'Executive Producer',
  'Producer',
  'Writer',
  'Director of Photography',
  'Editor',

  'Art Director',
  'Animator',
  'Cast',
  'Crew',
  'Script Supervisor',
  'Camera Assistant',
  'Gaffer',
  'Grip',
  'Art Assistant',
  'Wardrobe',
  'Hair & Makeup',
  'Sound Recordist',
  'Production Manager',
  'Production Assistant',

  'Offline Editor',
  'Online Editor',
  'Colourist',
  'Visual Effects',
  'Audio Post Production',
  'Sound Design',
  'Music Composer',
];



// WEBPACK FOOTER //
// ./src/assets/data/viddsee/collaboratorRoles.js